import React, { useState } from "react"

import { InputWithLabel } from "../../components/shared/Inputs"
import { AnimatedModal } from "../../components/shared/Modal"
import { RadioWithLabel } from "../../components/shared/RadioButtons"
import Typography from "../../components/shared/Typography"

const PAYMENT_OPTIONS = [
  { label: "Cash", value: "cash" },
  { label: "Venmo", value: "venmo" },
  { label: "PayPal", value: "paypal" },
  { label: "Other", value: "other" }
]

export default function MarkRegistrationPaidModal({ visible, hideModal, onSave, saving = false }) {
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("cash")
  const [otherPaymentOption, setOtherPaymentOption] = useState("")

  const handleSave = () => {
    const paidBy = selectedPaymentOption === "other" ? otherPaymentOption : selectedPaymentOption
    onSave(paidBy)
  }

  return (
    <AnimatedModal
      visible={visible}
      hideModal={hideModal}
      header="Mark as paid"
      showFooter={true}
      cancelButtonCopy="Cancel"
      cancelButtonType="tertiary"
      actionButtonCopy={saving ? "Saving..." : "Mark as paid"}
      actionButtonType="primary"
      saveDisabled={saving || (selectedPaymentOption === "other" && !otherPaymentOption.trim())}
      onSave={handleSave}>
      <div className="py-4 sm:pb-12">
        <Typography variant="body" className="mb-4 text-gray-dark">
          Marking paid records an offline payment in Heal.me. It does not charge the client&apos;s card through Stripe
          or Square.
        </Typography>
        <Typography variant="body" className="mb-6 text-gray-dark">
          You can note how an offline payment was made:
        </Typography>
        {PAYMENT_OPTIONS.map((option) => (
          <RadioWithLabel
            key={option.value}
            id={`registration-${option.value}`}
            label={option.label}
            checked={selectedPaymentOption === option.value}
            onChange={(event) => setSelectedPaymentOption(event.target.value)}
            value={option.value}
            name="registrationPaymentMethod"
            className="mb-4"
          />
        ))}
        {selectedPaymentOption === "other" && (
          <InputWithLabel
            label="Note how the client paid:"
            value={otherPaymentOption}
            onChange={(e) => setOtherPaymentOption(e.target.value)}
          />
        )}
      </div>
    </AnimatedModal>
  )
}
